/* eslint-disable jsx-a11y/anchor-is-valid */
import { t } from "i18next";
import { useSelector } from "react-redux";
import { EstimateModel, selectEstimate } from "../store/features/estimateSlice";
import {
  CategoryState,
  selectCategoryState,
} from "../store/features/categorySlice";
import "./../stylesheets/components/IPhoneSocialPreview.scss";

export default function IPhoneSocialPreview() {
  const state: EstimateModel = useSelector(selectEstimate);
  const categoryState: CategoryState = useSelector(selectCategoryState);

  return (
    <>
      <div className="preview-iphone">
        <div className="iphone">
          <div className="iphone-screen">
            <div id="social-preview" className="social-preview mobile">
              <div>
                <div className="_RAf" id="qslc">
                  <a className="_Ejh">
                    <div className="_Djh" aria-label="Facebook"></div>
                  </a>
                </div>
              </div>
              <div className="social-header">
                <div
                  className="social-logo"
                  ng-style="{'background-image':'url(' + rc.adImage + ')', 'background-size': '100% 100%'}"
                ></div>
                <div className="social-title">
                  {state.businessName || t("preview.social.companyName")}
                </div>
                <span className="social-sponsored">
                  {t("preview.social.sponsored")}
                </span>
                <span className="social-audience"></span>
              </div>
              <div className="social-copy">
                <span className="copy-1">
                  {categoryState.categoryAdCopy?.description ||
                    t("preview.social.description")}
                </span>
              </div>
              <div
                className="social-image"
                style={{
                  backgroundImage:
                    "url(" + categoryState.categoryAdCopy?.adImage + ")",
                }}
              ></div>
              <div className="social-headings">
                <div className="social-row">
                  <div className="social-left">
                    <div className="social-url">{t("preview.social.path")}</div>
                    <div>
                      <h2>
                        {categoryState.categoryAdCopy?.mainHeadline ||
                          t("preview.social.mainHeadline")}
                      </h2>
                      <h3>
                        {categoryState.categoryAdCopy?.subHeadline ||
                          t("preview.social.subHeadline")}
                      </h3>
                    </div>
                  </div>
                  <div className="social-right">
                    <span className="social-action">
                      {t("preview.social.contactUs")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="social-footer">
                <div className="inner">
                  <div>
                    <span>{t("preview.social.like")}</span>
                  </div>
                  <div>
                    <span className="comment">
                      {t("preview.social.comment")}
                    </span>
                  </div>
                  <div>
                    <span className="share">{t("preview.social.share")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
